import React, { useRef } from 'react';

import { Box, Flex, Text } from '@chakra-ui/react';

import { EmailCollectionInput } from './EmailCollectionInput';
import { Store } from '../../store';

export const EmailCollection: React.FC<{
  submitEmail: (email: string) => void;
  skipEmail?: () => void;
  emailSubmission?: { censored?: string; completed?: boolean };
  emailSkipped?: boolean;
  emailPrompt: string;
  submitLabel: string;
  includeCount?: boolean;
}> = (props) => {
  const { submitEmail, emailSubmission, emailSkipped, emailPrompt, submitLabel, includeCount, skipEmail } =
    props;

  const containerRef = useRef<null | HTMLDivElement>(null);
  const labels = Store.useState((s) => s.labels);
  return (
    <Box ref={containerRef}>
      <Flex align="flex-start" justify="space-between">
        <Text variant="paragraph-medium" id="remark-email-collection">
          {emailPrompt}
        </Text>
        {includeCount && (
          <Text variant="paragraph-small" color="scheme.contentTertiary" ml="8px" minW="34px">
            2 {labels.of} 2
          </Text>
        )}
      </Flex>

      <EmailCollectionInput
        submitLabel={submitLabel}
        submitEmail={submitEmail}
        skipEmail={skipEmail}
        emailSkipped={emailSkipped}
        emailSubmission={emailSubmission}
        isIntroSequence={includeCount ?? false}
        containerRef={containerRef}
      />
    </Box>
  );
};
